import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'
import mainTheme from 'src/styles/Theme'

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: ${(props) => (props.isScrollable ? 'initial' : 'hidden')};
  }

  body {
    font-family: ${(props) => props.theme.font.family.main};
    font-size: ${(props) => props.theme.font.size[14]};
    font-weight: ${(props) => props.theme.font.weight.s};
    color: ${(props) => props.theme.color.text.main};
  }

  ${(props) =>
    Object.keys(props.theme.color.face).map(
      (key) =>
        `.bg-${key} { background-color: ${props.theme.color.face[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.color.text).map(
      (key) => `.text-${key} { color: ${props.theme.color.text[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.family).map(
      (key) =>
        `.font-family-${key} { font-family: ${props.theme.font.family[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.size).map(
      (key) => `.font-size-${key} { font-size: ${props.theme.font.size[key]}; }`
    )}

  ${(props) =>
    Object.keys(props.theme.font.weight).map(
      (key) =>
        `.font-weight-${key} { font-weight: ${props.theme.font.weight[key]}; }`
    )}

  p {
    letter-spacing: ${(props) => props.theme.font.spacing.xs}
  }

  a {
    color: inherit;

    &:hover {
      color: inherit;
    }
  }
`

const Theme = ({ children, isScrollable = true }) => (
  <ThemeProvider theme={mainTheme}>
    <GlobalStyle isScrollable={isScrollable} />
    {children}
  </ThemeProvider>
)

export default Theme
